
import React, { useState } from "react";
import {
  useNavigate,
  Link,
  useSearchParams,
} from "react-router-dom";
import { API_BASE } from "../api/api";
import { useAuth } from "../context/AuthContext";


export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

const [searchParams] = useSearchParams();

const redirect =
  searchParams.get("redirect") || "/";


const { login } = useAuth();

  const handleLogin = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const res = await fetch(
      `${API_BASE}/api/auth/login`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          identifier,
          password,
        }),
      }
    );

    const data = await res.json();

    if (!res.ok) {
      alert(
        data.error ||
        data.message ||
        "Login failed"
      );
      return;
    }

    // Save user session
    login(data.token, data.user);

    // Navigate to requested page
    navigate(redirect, {
      replace: true,
    });

  } catch (err) {
    console.error("LOGIN ERROR:", err);
    alert("Error logging in");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded shadow">
      <h1 className="text-2xl font-bold mb-4">Login</h1>
      <form onSubmit={handleLogin} className="flex flex-col gap-4">
        <input
  type="text"
  placeholder="Email or phone number"
  className="p-2 border rounded"
  value={identifier}
  onChange={(e) => setIdentifier(e.target.value)}
  required
/>
        <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            placeholder="Password"
            className="p-2 border rounded w-full"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-2 top-2 text-sm text-gray-600"
          >
            {showPassword ? "Hide" : "Show"}
          </button>
        </div>
        <button
          type="submit"
          disabled={loading}
          className="bg-green-600 text-white p-2 rounded hover:bg-green-700 flex justify-center items-center"
        >
          {loading && (
            <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-5 h-5 mr-2"></span>
          )}
          {loading ? "Logging in..." : "Login"}
        </button>
      </form>
      <div className="mt-4 text-sm text-gray-600 flex justify-between">
        <span>
          Don't have an account?{" "}
          <Link
  to={`/register?redirect=${encodeURIComponent(redirect)}`}
  className="text-blue-600"
>
            Register
          </Link>
        </span>
        <span>
          <Link to="/forgot-password" className="text-blue-600">
            Forgot Password?
          </Link>
        </span>
      </div>

<script async="async" data-cfasync="false" src="https://pl29467278.effectivecpmnetwork.com/1ac49ab91139c0ad3e13572497cfbe18/invoke.js"></script>
<div id="container-1ac49ab91139c0ad3e13572497cfbe18"></div>


    </div>
  );
}